export default (theme) => ({
    ...theme.softpro.tableColumns,
});
